import { resolveLink as n } from "../../../helpers/index.js";
import { useLanguage as o } from "@ingeniorforeningen/figurine-core";
const a = (e) => {
  const { language: r } = o(), i = { da: "Kr./Måned", en: "DKK/Month" }, t = { da: "inkl. gebyr", en: "incl. fees" }, s = { da: "Forsikring", en: "Insurance" }, p = { da: "Forsikringen dækker:", en: "The Insurance covers:" };
  return {
    header: e.properties?.header,
    cta: {
      text: e.properties?.buttonLabel,
      href: "https://tilbud.idaforsikring.dk/studieberegner"
    },
    cards: [
      {
        text: p[r],
        subject: s[r],
        priceSecondary: ",-",
        priceText: i[r],
        priceTerms: t[r],
        header: e.properties?.homeHeader,
        illustration: "house",
        textList: e.properties?.homeAdvantages,
        price: e.properties?.homePrice,
        link: e.properties?.homeDetailLink && n(e.properties?.homeDetailLink),
        type: "indbo"
      },
      {
        text: p[r],
        subject: s[r],
        priceSecondary: ",-",
        priceText: i[r],
        priceTerms: t[r],
        header: e.properties?.travelHeader,
        illustration: "suitcase",
        textList: e.properties?.travelAdvantages,
        price: e.properties?.travelPrice,
        link: e.properties?.travelDetailLink && n(e.properties?.travelDetailLink),
        type: "rejse"
      },
      {
        text: p[r],
        subject: s[r],
        priceSecondary: ",-",
        priceText: i[r],
        priceTerms: t[r],
        header: e.properties?.accidentHeader,
        illustration: "heartbeat",
        textList: e.properties?.accidentAdvantages,
        price: e.properties?.accidentPrice,
        link: e.properties?.accidentDetailLink && n(e.properties?.accidentDetailLink),
        type: "ulykke"
      }
    ]
  };
};
export {
  a as productselectorDeliveryApiParser
};
